export const MobileCategorySelectionItems = (props) => {
  function handleClick(tabName) {
    $("html, body").animate({
      scrollTop: $("#step-1-headline").offset().top - 35,
    });
    props.changeTab(tabName);
    props.loadCategory(tabName);
  }

  var true_icon = <img src="/true.png" title="Vybráno" />;
  var false_icon = <img src="/false.png" title="Nevybráno" />;
  return (
    <table id="mobile-category-selection-items">
      <tbody>
        <tr id="menu">
          <td
            className={
              props.selectedCategory === "ovens" ? "link active" : "link"
            }
            onClick={() => handleClick("ovens")}
          >
            {"Vestavná trouba"}
          </td>
          <td
            className={
              props.selectedCategory === "hobs" ? "link active" : "link"
            }
            onClick={() => handleClick("hobs")}
          >
            {"Varná deska"}
          </td>
          <td
            className={
              props.selectedCategory === "dishwashers" ? "link active" : "link"
            }
            onClick={() => handleClick("dishwashers")}
          >
            {"Myčka nádobí"}
          </td>
          <td
            className={
              props.selectedCategory === "microwaves" ? "link active" : "link"
            }
            onClick={() => handleClick("microwaves")}
          >
            {"Mikrovlnná trouba"}
          </td>
          <td
            className={
              props.selectedCategory === "extractors" ? "link active" : "link"
            }
            onClick={() => handleClick("extractors")}
          >
            {"Odsavač par"}
          </td>
          <td
            className={
              props.selectedCategory === "fridges" ? "link active" : "link"
            }
            onClick={() => handleClick("fridges")}
          >
            {"Lednička"}
          </td>
        </tr>

        <tr id="menu">
          <td
            className={
              props.selectedCategory === "ovens" ? "link active" : "link"
            }
            onClick={() => handleClick("ovens")}
          >
            {props.items[0][1].price > 0 ? true_icon : false_icon}
          </td>
          <td
            className={
              props.selectedCategory === "hobs" ? "link active" : "link"
            }
            onClick={() => handleClick("hobs")}
          >
            {props.items[1][1].price > 0 ? true_icon : false_icon}
          </td>
          <td
            className={
              props.selectedCategory === "dishwashers" ? "link active" : "link"
            }
            onClick={() => handleClick("dishwashers")}
          >
            {props.items[2][1].price > 0 ? true_icon : false_icon}
          </td>
          <td
            className={
              props.selectedCategory === "microwaves" ? "link active" : "link"
            }
            onClick={() => handleClick("microwaves")}
          >
            {props.items[3][1].price > 0 ? true_icon : false_icon}
          </td>
          <td
            className={
              props.selectedCategory === "extractors" ? "link active" : "link"
            }
            onClick={() => handleClick("extractors")}
          >
            {props.items[4][1].price > 0 ? true_icon : false_icon}
          </td>
          <td
            className={
              props.selectedCategory === "fridges" ? "link active" : "link"
            }
            onClick={() => handleClick("fridges")}
          >
            {props.items[5][1].price > 0 ? true_icon : false_icon}
          </td>
        </tr>

        <tr>
          <td colSpan={6} onClick={() => props.handleGoOnFilter()}>
            Zobrazit filtraci »
          </td>
        </tr>
      </tbody>
    </table>
  );
};
